import { ErrorMessage } from '@hookform/error-message'
import { CommentsIcon, DummyImage, HappyIcon, LikeIcon } from 'assets'
import { CustomModal } from 'components'
import { emotionIcon, emotionType } from 'constant/const'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { resetUpdateCommentStatus, updateCommentsAction } from 'store/action/videoReducer'
import { convertObjectToFormData } from 'utils/convertFormData'
import { formatNumber } from 'utils/formatNumber'
import { getEmotionIcon } from 'utils/getEmotionIcon'
import { getSentimentIcon } from 'utils/getSentimentIcon'
import { removeUtcFormate } from 'utils/removeUtcFormate'

function CommentsEditModal({ onClose, commentOpenModal, item }) {
   const params = useParams()
   const [selectedSentimentType, setSelectedSentimentType] = useState(item?.sentiment)
   const [selectedEmotion, setSelectedEmotion] = useState(item?.emotion)
   const settingData = useSelector((state) => state.settings)
   const { selectedChannelID } = settingData
   const dispatch = useDispatch()
   const videoReduxData = useSelector((state) => state.videoRedux)
   const { updateCommentStatus, updateCommentLoading } = videoReduxData
   const {
      setValue,
      handleSubmit,
      register,
      formState: { errors },
      setError,
      clearErrors
   } = useForm()
   const [charCount, setCharCount] = useState(0)
   const [showThankYouScreen, setShowThankYouScreen] = useState(false)

   register('message', { required: { value: true, message: 'Please enter the message' } })
   register('emotion', { required: { value: true, message: 'Please select the emotion' } })
   useEffect(() => {
      if (item) {
         setValue('sentiment', item?.sentiment)
         setValue('emotion', item?.emotion?.toLocaleLowerCase())
      }
      return () => {}
   }, [item])

   const handleTextChange = (event) => {
      const text = event.target.value
      setCharCount(text.length)
      if (text) {
         clearErrors('message')
      } else {
         setError('message', { message: 'Please enter the message' })
      }
      setValue('message', text)
   }

   const onChangeSentiment = (type) => {
      setSelectedSentimentType(type)
      setValue('sentiment', type)
      setValue('emotion', null)
      setSelectedEmotion(null)
   }

   useEffect(() => {
      if (updateCommentStatus) {
         setShowThankYouScreen(true)
         dispatch(resetUpdateCommentStatus())
         onClose()
      }

      return () => {}
   }, [updateCommentStatus])

   const onSubmit = (data) => {
      const su_data = {
         channel_id: selectedChannelID,
         video_id: params?.id,
         comment_id: item?.comment_id,
         edited_emotion: data.emotion,
         edited_sentiment: data?.sentiment,
         note: data?.message
      }
      let formData = convertObjectToFormData(su_data)
      console.log(su_data)
      dispatch(updateCommentsAction(formData))
   }
   return (
      <div>
         <CustomModal
            show={commentOpenModal}
            title={'Flag Comment'}
            closeModal={onClose}
            centered
            size="lg"
            scrollable
            footerComponent={
               <>
                  <div className="feedback-btn-group">
                     <button className={`atenya-ai-btn `} onClick={onClose}>
                        <span className="content-text">Cancel</span>
                     </button>
                     <Button
                        className="at-auth-btn w-100"
                        disabled={updateCommentLoading}
                        onClick={handleSubmit(onSubmit)}>
                        {updateCommentLoading ? 'Updating....' : 'Confirm'}
                     </Button>
                  </div>
               </>
            }>
            <>
               <div className="mb-3">
                  <p className="at-text-light">
                     Select a new sentiment or emotion if the current label doesn’t match your
                     interpretation. Adding context below helps us understand your perspective and
                     improve results over time.
                  </p>
               </div>
               <div className="comment-edit-modal comment-wrap">
                  <div className="card comment-card">
                     <div className="comment-card-border"></div>
                     <div className="comment-details">
                        <div className="comment-name-section">
                           <div className="name-image-section">
                              <img src={DummyImage} alt="user" />
                              <div className="name-date-wrap">
                                 <span>{item?.author_name} </span>
                                 <span className="at-text-light">
                                    {' '}
                                    {item?.published_at
                                       ? dayjs(removeUtcFormate(item?.published_at)).format(
                                            'D MMMM, YYYY'
                                         )
                                       : ''}
                                 </span>
                              </div>
                           </div>
                           <div className="filter">
                              <div className="comment-count video-icon ">
                                 <div className="d-flex align-items-center gap-2 video-icon-wrap">
                                    <div className="at-video-icon">
                                       {getSentimentIcon(item?.sentiment)}
                                    </div>
                                    <span className=" at-text-light video-counter text-capitalize">
                                       {item?.sentiment}
                                    </span>
                                 </div>
                                 <div className="d-flex align-items-center gap-2 video-icon-wrap">
                                    <div className="at-video-icon">
                                       {getEmotionIcon(item?.emotion, item?.sentiment)}
                                    </div>
                                    <span className=" at-text-light video-counter text-capitalize">
                                       {item?.emotion}
                                    </span>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div className="comment-content">{item?.text}</div>
                        <div className="comment-count video-icon mt-3">
                           <div className="d-flex align-items-center gap-2 video-icon-wrap">
                              <div className="at-video-icon">
                                 <LikeIcon />
                              </div>
                              <span className=" at-text-light video-counter">
                                 {formatNumber(item?.comment_likes || 0, 2)}
                              </span>
                           </div>
                           <div className="d-flex align-items-center gap-2 video-icon-wrap">
                              <div className="at-video-icon">
                                 <CommentsIcon />
                              </div>
                              <span className=" at-text-light video-counter">
                                 {formatNumber(item?.num_replies || 0, 2)}
                              </span>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="emotion-sentiment-type-filter">
                  <div
                     className={`sentiment-type-wrap ${
                        selectedSentimentType === emotionType.Positive ? 'active' : ''
                     }  `}
                     onClick={() => {
                        onChangeSentiment(emotionType.Positive)
                     }}>
                     <p>Positive</p>
                     {getSentimentIcon(emotionType.Positive)}
                  </div>
                  <div
                     className={`sentiment-type-wrap ${
                        selectedSentimentType === emotionType.Neutral ? 'active' : ''
                     }  `}
                     onClick={() => {
                        onChangeSentiment(emotionType.Neutral)
                     }}>
                     <p>Neutral</p>
                     {getSentimentIcon(emotionType.Neutral)}
                  </div>
                  <div
                     className={`sentiment-type-wrap ${
                        selectedSentimentType === emotionType.Negative ? 'active' : ''
                     }  `}
                     onClick={() => {
                        onChangeSentiment(emotionType.Negative)
                     }}>
                     <p>Negative</p>
                     {getSentimentIcon(emotionType.Negative)}
                  </div>
               </div>
               <div className="list-of-emotion mt-3">
                  <p className="at-text-light label-feedback">
                     Select the emotion associated with this comments
                  </p>
                  <div className="mt-2 d-flex flex-wrap gap-3 justify-content-start align-content-center">
                     {emotionIcon &&
                        emotionIcon?.length > 0 &&
                        emotionIcon
                           ?.filter((it) => it.type === selectedSentimentType)
                           .map((it, i) => (
                              <div
                                 className={`emotion-wrap ${
                                    selectedEmotion?.toLocaleLowerCase() ===
                                    it.name?.toLocaleLowerCase()
                                       ? 'active'
                                       : ''
                                 }`}
                                 onClick={() => {
                                    setSelectedEmotion(it.name?.toLocaleLowerCase())
                                    setValue('emotion', it.name?.toLocaleLowerCase())
                                    clearErrors('emotion')
                                 }}
                                 key={i}>
                                 {it.icon}
                                 <span className="text-capitalize">{it.name}</span>
                              </div>
                           ))}
                  </div>
                  {errors?.emotion && (
                     <span className="error-text mt-2 d-inline-block">
                        <ErrorMessage errors={errors} name="emotion" message={errors?.emotion} />
                     </span>
                  )}
               </div>
               <div className="mt-3">
                  <div className="label-text-wrap">
                     <label className="at-text-light mb-2 label-feedback">
                        What’s wrong with this comment?
                     </label>
                     <span className="at-text-light label-feedback">{charCount}/500</span>
                  </div>
                  <textarea
                     className={`form-control feedback-textarea ${errors?.message ? 'error' : ''} `}
                     placeholder="Note here..."
                     rows={4}
                     maxLength={500}
                     onChange={handleTextChange}></textarea>
                  {errors?.message && (
                     <span className="error-text mt-2 d-inline-block">
                        <ErrorMessage errors={errors} name="message" message={errors?.message} />
                     </span>
                  )}
               </div>
            </>
         </CustomModal>
      </div>
   )
}

export default CommentsEditModal
